import { ApiResponseModel } from "../shared/models/ApiResponse.model";
import { ErrorMessageEnumApi } from "../shared/enums/error-message.enum";

const errorResponseHandler = (res: ApiResponseModel, setError: any, setIsLoading: any, setSectionNumber: any, type?: string) => {
	const result = res.result;

	switch (result.code) {
		case "resetpwd-001":
			setIsLoading(false);
			switch (type) {
				case "email-send":
					setSectionNumber(1);
					break;
				case "sms-send":
					setSectionNumber(3);
					break;
			}
			setError("root.serverError", {
				type: "general",
				message: ErrorMessageEnumApi.RESET_PWD_001,
			});
			return ErrorMessageEnumApi.RESET_PWD_001;
		case "resetpwd-002":
			setError("root.serverError", {
				type: "general",
				message: ErrorMessageEnumApi.RESET_PWD_002,
			});
			setSectionNumber(1);
			setIsLoading(false);
			return ErrorMessageEnumApi.RESET_PWD_002;
		case "resetpwd-003":
			setError("root.serverError", {
				type: "general",
				message: ErrorMessageEnumApi.RESET_PWD_003,
			});
			setSectionNumber(1);
			setIsLoading(false);
			return ErrorMessageEnumApi.RESET_PWD_003;
		case "resetpwd-004":
			setError("pin", {
				type: "resetpwd-004",
				message: ErrorMessageEnumApi.RESET_PWD_004,
			});
			setError("root.serverError", {
				type: "general",
				message: ErrorMessageEnumApi.RESET_PWD_004,
			});
			setIsLoading(false);
			return ErrorMessageEnumApi.RESET_PWD_004;
		case "resetpwd-005":
			setError("email", {
				type: "resetpwd-005",
				message: ErrorMessageEnumApi.RESET_PWD_005,
			});
			setError("root.serverError", {
				type: "general",
				message: ErrorMessageEnumApi.RESET_PWD_005,
			});
			setIsLoading(false);
			return ErrorMessageEnumApi.RESET_PWD_005;
		case "resetpwd-006":
			setError("root.serverError", {
				type: "general",
				message: ErrorMessageEnumApi.RESET_PWD_006,
			});
			setIsLoading(false);
			setSectionNumber(1);
			return ErrorMessageEnumApi.RESET_PWD_006;
		case "resetpwd-999":
			return setError("root.serverError", {
				type: "general",
				message: ErrorMessageEnumApi.RESET_PWD_999,
			});
		case "ratelimit-001":
			setIsLoading(false);
			switch (type) {
				case "email-send":
					setSectionNumber(1);
					break;
				case "sms-send":
					setSectionNumber(3);
					break;
			}
			return setError('root.serverError', {
				type: 'general',
				message: ErrorMessageEnumApi.RATELIMIT_001,
			});
	}
};

export { errorResponseHandler };
